
















































































































































































import _ from "lodash";
import { Watch, Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import { Maintenancejob, Customer } from "@/models";
import { MaintenancejobsState } from "@/store/maintenancejobs/types";
import ProgressButton from "@/components/ProgressButton.vue";

@Component({
  components: {
    ProgressButton,
  },
})
export default class JobList extends Vue {
  @State("maintenancejobs") public maintenancejobsState: MaintenancejobsState;

  @Getter("app/hasBlockingRequests") public hasBlockingRequests: boolean;
  @Getter("maintenancejobs/list") public list: Maintenancejob[];
  @Action("customers/getCustomers") getCustomers: () => Promise<void>;
  @Action("contractors/getContractors") getContractors: () => Promise<void>;
  @Action("maintenancejobs/getMaintenancejobsforinvoice")
  getMaintenancejobsforinvoice: () => Promise<void>;
  @Action("maintenancejobs/setSearch")
  public setSearch: (search: string) => Promise<any>;
  @Action("maintenancejobs/setFilterCustomer")
  public setFilterCustomer: (customer: string) => Promise<any>;
  @Action("maintenancejobs/setFilterContractor")
  public setFilterContractor: (customer: string) => Promise<any>;
  @Action("maintenancejobs/setFilterInvoiceStatus")
  public setFilterInvoiceStatus: (status: string) => Promise<any>;
  @Mutation("maintenancejobs/setCurrent")
  public setCurrent: (maintenancejob: Maintenancejob) => void;
  @Mutation("app/removeRequest")
  public removeRequest: (id: string) => void;

  @Getter("contractors/list") public contractorslist: Customer[];
  public contractorsOptions: { value: string; label: string }[] = [];
  @Getter("customers/list") public customerlist: Customer[];
  public customerOptions: { value: string; label: string }[] = [];
  @Action("maintenancejobs/deleteMaintenancejob") deleteStoreMaintenancejob: (
    maintenancejob: Maintenancejob
  ) => Promise<void>;
  @Action("maintenancejobs/generateMaintenancejobPdf")
  generateMaintenancejobPdf: (payload: {
    maintenancejob: Maintenancejob;
    downloadType: string;
  }) => Promise<any>;
  @Getter("maintenancejobs/current") public maintenancejob: Maintenancejob;
  public qry = {};
  @Action("maintenancejobs/setMaintenancejobDeep")
  public setMaintenancejobDeep: (payload: {
    path: string;
    data: any;
  }) => Promise<any>;
  @Action("maintenancejobs/updateMaintenancejobPayment")
  public updateMaintenancejobPayment: (
    maintenancejob: Maintenancejob
  ) => Promise<any>;

  public async mounted() {
    if (this.customerlist.length == 0) {
      await Promise.all([this.getCustomers()])
        .then(() => {
          this.setCustomerOptions();
        })
        .catch((err: any) => this.$onecentral.displayError(err));
    } else {
      this.setCustomerOptions();
    }
    if (this.contractorslist.length == 0) {
      await Promise.all([this.getContractors()])
        .then(() => {
          this.setContractorOptions();
        })
        .catch((err: any) => this.$onecentral.displayError(err));
    } else {
      this.setContractorOptions();
    }
  }

  public async setCustomerOptions() {
    this.customerOptions = Array.from(this.customerlist).map((b) => ({
      value: b.id,
      label: b.companyName,
    }));
  }
  public async setContractorOptions() {
    this.contractorsOptions = Array.from(this.contractorslist).map((b) => ({
      value: b.id,
      label: b.companyName,
    }));
  }

  get search(): string | undefined {
    return this.maintenancejobsState.search;
  }
  set search(val: string | undefined) {
    this.setSearch(val ? val : "");
  }

  // Watch for when the "filtercustomer" query param changes...
  @Watch("$route.query.filtercustomer")
  public onCustomerChange(val: string, oldVal: string) {
    if (val) {
      this.setFilterCustomer(val).then(() => this.getMaintenancejobsforinvoice());
    }
  }
  // Watch for when the "filtercontractor" query param changes...
  @Watch("$route.query.filtercontractor")
  public onContractorChange(val: string, oldVal: string) {
    if (val) {
      this.setFilterContractor(val).then(() => this.getMaintenancejobsforinvoice());
    }
  }
  // ...and also when the "search" query param changes
  @Watch("$route.query.search")
  public onSearchChanged(val: string, oldVal: string) {
    if (val) {
      this.setSearch(val).then(() => this.getMaintenancejobsforinvoice());
    }
  }
  // Watch for when the "invoiceFilterStatus" query param changes...
  @Watch("$route.query.invoiceFilterStatus")
  public onStatusChange(val: string) {
    if (val) {
      this.setFilterInvoiceStatus(val).then(() => this.getMaintenancejobsforinvoice());
    }
  }

  public editMaintenancejob(maintenancejob: Maintenancejob): void {
    this.$router.push({
      name: "edit-invoice",
      params: { id: maintenancejob.id || "" },
    });
  }
  public onCustomerSelect(selected: any) {
    if (selected !== null) {
      this.query.filtercustomer = selected.value;
      this.$router.push({ path: "invoices", query: this.query });
    }
  }
  public onContractorSelect(selected: any) {
    if (selected !== null) {
      this.query.filtercontractor = selected.value;
      this.$router.push({ path: "invoices", query: this.query });
    }
  }

  public onStatusSelect(selected: any) {
    if (selected !== null) {
      this.query.invoiceFilterStatus = selected;
      this.$router.push({ path: "invoices", query: this.query });
    }
  }

  public clearCustomerfilter() {
    this.setFilterCustomer("");
    this.query.filtercustomer = undefined;
    this.$router.push({ path: "invoices", query: this.query });
    this.getMaintenancejobsforinvoice();
  }
  public clearContractorfilter() {
    this.setFilterContractor("");
    this.query.filtercontractor = undefined;
    this.$router.push({ path: "invoices", query: this.query });
    this.getMaintenancejobsforinvoice();
  }

  public setBooleanValue(val: boolean, maintenancejob: Maintenancejob) {
    maintenancejob.payment = val;
    this.updateMaintenancejobPayment(maintenancejob);
  }

  public clearStatusfilter() {
    this.setFilterInvoiceStatus("");
    this.query.invoiceFilterStatus = undefined;
    this.$router.push({ path: "invoices", query: this.query });
    this.getMaintenancejobsforinvoice();
  }

  public deleteMaintenancejob(maintenancejob: Maintenancejob): void {
    this.$onecentral
      .confirmPrompt()
      .then(() => this.deleteStoreMaintenancejob(maintenancejob))
      .then(() => Vue.toasted.success("Maintenancejob deleted"))
      .catch((err: any) => this.$onecentral.displayError(err));
  }

  public created(): void {
    if(this.maintenancejobsState.invoiceFilterStatus === undefined){
      this.maintenancejobsState.invoiceFilterStatus = "To be invoiced";
      this.query.invoiceFilterStatus = "To be invoiced";
    }
    if(this.maintenancejobsState.invoiceFilterStatus){
      this.query.invoiceFilterStatus = this.maintenancejobsState.invoiceFilterStatus;
      this.$router.push({ path: "invoices", query: this.query });
    } else if (this.maintenancejobsState.filterCustomer) {
      this.$router.push({
        path: "invoices",
        query: { customer: this.maintenancejobsState.filterCustomer },
      });
    } else if (this.maintenancejobsState.search) {
      this.$router.push({
        path: "invoices",
        query: { search: this.maintenancejobsState.search },
      });
    } else if (this.maintenancejobsState.filterContractor) {
      this.$router.push({
        path: "invoices",
        query: { search: this.maintenancejobsState.filterContractor },
      });
    } else {
      this.getMaintenancejobsforinvoice();
    }
  }

  get filtercustomer(): { value: string; label: string } | undefined {
    return this.customerOptions.find((x: { value: string; label: string }) => {
      return x.value === this.maintenancejobsState.filterCustomer;
    });
  }
  get filtercontractor(): { value: string; label: string } | undefined {
    return this.contractorsOptions.find(
      (x: { value: string; label: string }) => {
        return x.value === this.maintenancejobsState.filterContractor;
      }
    );
  }

  get invoiceFilterStatus() {
    return this.maintenancejobsState.invoiceFilterStatus;
  }

  /**
   * Search through maintenancejobs by string
   */
  public onSubmit() {
    this.query.search = this.search;
    this.$router.push({ path: "invoices", query: this.query });
  }

  get query() {
    return this.qry;
  }
  set query(val: any) {
    this.qry = val;
  }

  public statusOptions: string[] = ["All", "Outstanding", "Paid"];

  public showEmailReportDialog(maintenancejob: Maintenancejob) {
    let modal: any = this.$refs.quotationEmailModal as any;
    modal.init(maintenancejob);
    document.body.appendChild(modal.$el);
    ($(modal.$el) as any).modal("show");
  }
  /**
   * Download Maintenancejob/Invoice/Proforma PDF
   *
   * @param {Maintenancejob} maintenancejob
   * @param {String} downloadType
   */
  public generatePdf(
    maintenancejob: Maintenancejob,
    downloadType: string,
    requestId: string
  ): void {
    this.generateMaintenancejobPdf({ maintenancejob, downloadType })
      .then((key: string) => {
        this.$onecentral.downloadAttachment(key);
        this.$toasted.success(
          `${downloadType} for ${maintenancejob.ref} PDF downloaded`
        );
      })
      .finally(() => this.removeRequest(requestId))
      .catch((err: any) => this.$onecentral.displayError(err));
  }
}
